<template>
  <v-menu
      offset-y
      :nudge-bottom="8"
      :close-on-content-click="false"
      max-width="300"
      class="bulk-actions-edit"
      v-model="showMenu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          class="bulk-actions__button-edit"
          :class="{ '__disabled': props.disabled }"
          v-bind="attrs"
          v-on="on"
          outlined
          flat
          :disabled="props.disabled"
      >
        <v-icon
            v-if="selectedActionIcon"
            :color="props.disabled ? '#E0E0E0' : '#344054'"
            class="bulk-actions__selected-icon-edit mr-2"
        >
          {{ `$${ selectedActionIcon }` }}
        </v-icon>
        <span
            class="font-weight-regular bulk-actions__button__text-edit"
            :class="{ '__disabled': props.disabled }"
        >
          {{ selectedActionText || 'Bulk Actions' }} <span v-if="selectedItemsCounter > 0">({{ selectedItemsCounter }})</span>
        </span>
        <v-icon
            :color="props.disabled ? '#E0E0E0' : '#344054'"
            class="bulk-actions__icon-edit ml-2"
            :class="{ 'bulk-actions__icon-edit--rotated': showMenu }"
        >
          $ex-chevron-up-rounded
        </v-icon>
      </v-btn>
    </template>

    <v-card class="bulk-actions__menu-edit pa-0">
      <v-list>
        <v-list-item
            v-for="(action, index) in actions"
            :key="index"
            @click="handleAction(action.type)"
            class="bulk-actions__item-edit"
            :class="{ 'bulk-actions__item-edit--selected': action.type === selectedType }"
        >
          <v-list-item-icon>
            <v-icon class="text-white mr-2">{{ `$${ action.icon }` }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="action-text-edit font-weight-regular">
              {{ action.text }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

const showMenu = ref(false)
const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: String,
    default: null
  },
  selectedItemsCounter: {
    type: Number,
    default: 0
  }
});

const emit = defineEmits(['update:modelValue', 'select'])

const actions = [
  {
    text: 'Activate',
    icon: 'ex-bulk-action-active',
    iconColor: 'grey darken-1',
    type: 'activate'
  },
  {
    text: 'Move',
    icon: 'ex-bulk-action-move',
    iconColor: 'grey darken-1',
    type: 'move'
  },
  {
    text: 'Retire',
    icon: 'ex-bulk-action-active',
    iconColor: 'grey darken-1',
    type: 'retire'
  },
  {
    text: 'Archive',
    icon: 'ex-bulk-action-archive',
    iconColor: 'grey darken-1',
    type: 'archive'
  },
  {
    text: 'Delete',
    icon: 'ex-bulk-action-delete',
    iconColor: 'grey darken-1',
    type: 'delete'
  }
]

const selectedType = ref(props.modelValue)

watch(
  () => props.modelValue,
  (next) => {
    selectedType.value = next
  }
)

const selectedActionText = computed(() => {
  const match = actions.find((a) => a.type === selectedType.value)
  return match?.text ?? null
})

const selectedActionIcon = computed(() => {
  const match = actions.find((a) => a.type === selectedType.value)
  return match?.icon ?? null
})

const handleAction = (type) => {
  selectedType.value = type
  emit('update:modelValue', type)
  emit('select', type)
  showMenu.value = false
}
</script>

<style scoped>
.bulk-actions__button-edit {
  background: white !important;
  border: 1px solid #D0D5DD;
  border-radius: 8px !important;
  padding: 19px 18px !important;
}
.bulk-actions__button-edit.__disabled {
  border: 1px solid #E0E0E0;
}
.bulk-actions__button-edit::before {
  background-color: white !important;
}
.bulk-actions__button__text-edit {
  font-size: 14px;
  font-weight: 600 !important;
  line-height: 20px;
  text-decoration-skip-ink: none;
  color: #344054;
  text-transform: capitalize;
  letter-spacing: 0 !important;
}

.bulk-actions__button__text-edit.__disabled {
  color: #E0E0E0;
}

.bulk-actions__selected-icon-edit {
  font-size: 16px;
}

::v-deep.v-btn--disabled .bulk-actions__icon-edit svg path {
  stroke: #E0E0E0;
}

.bulk-actions__menu-edit {
  box-shadow: none !important;
  border-radius: 12px !important;
}

.bulk-actions__item-edit {
  transition: background-color 0.2s ease;
  margin: 4px !important;
  box-shadow: none;
  border-radius: 12px !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
  max-height: 48px !important;
}

.bulk-actions__item-edit:hover {
  background-color: #F9FAFB !important;
}

.bulk-actions__item-edit--selected {
  background-color: #F9FAFB !important;
}

.bulk-actions__item-edit::before {
  background-color: white !important;
}

.bulk-actions__item-edit .action-text-edit {
  font-size: 16px;
  font-weight: 500 !important;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  color: #344054;
}

.bulk-actions__icon-edit {
  transition: transform 0.2s ease;
}

.bulk-actions__icon-edit--rotated {
  transform: rotate(180deg);
}

.v-list-item__icon {
  margin: 8px 0 !important;
}

.v-list-item__content {
  padding: 8px 0 !important;
}
.v-menu__content {
  box-shadow: 0px 4px 6px -2px #10182808, 0px 12px 16px -4px #10182814 !important;
  border: 1px solid #EAECF0 !important;
  border-radius: 12px !important;
}
</style>
